import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";

import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

// Public Screens
import LandingPage from "./pages/landing-page";
import LoginScreen from "./pages/login-screen";
import RegistrationScreen from "./pages/registration-screen";
import GcAbout from "./pages/gc-about";
import PaymentPage from "./pages/payment";
import PaymentSuccessPhotoUpload from "./pages/PaymentSuccessPhotoUpload";

// Private Screens
import Dashboard from "./pages/dashboard";
import NewAnalysis from "./pages/new-analysis";
import AnalysisResult from "./pages/analysis-result";
import AnalysisResultVideo from "./pages/analysis-result-video";
import AccountSettings from "./pages/account-settings";
import AccountProfile from "./pages/account-profile";

import { isAuthed } from "./lib/cognito";

// -------------------------------------------
// PRIVATE ROUTE WRAPPER
// -------------------------------------------
function PrivateRoute({ children }) {
  const [auth, setAuth] = useState({ loading: true, ok: false });

  useEffect(() => {
    let mounted = true;

    isAuthed().then((ok) => {
      if (mounted) {
        setAuth({ loading: false, ok });
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (auth.loading) return null;
  if (!auth.ok) return <Navigate to="/login-screen" replace />;

  return children;
}

// -------------------------------------------
// ROUTES
// -------------------------------------------
const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />

        <RouterRoutes>
          {/* PUBLIC */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/login-screen" element={<LoginScreen />} />
          <Route path="/registration-screen" element={<RegistrationScreen />} />
          <Route path="/gc-about" element={<GcAbout />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route
            path="/payment-success-photoupload"
            element={<PaymentSuccessPhotoUpload />}
          />

          {/* PRIVATE */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/new-analysis"
            element={
              <PrivateRoute>
                <NewAnalysis />
              </PrivateRoute>
            }
          />

          {/* IMAGE ANALYSIS RESULT */}
          <Route
            path="/analysis-result"
            element={
              <PrivateRoute>
                <AnalysisResult />
              </PrivateRoute>
            }
          />

          {/* VIDEO ANALYSIS RESULT */}
          <Route
            path="/analysis-result-video/:jobId"
            element={
              <PrivateRoute>
                <AnalysisResultVideo />
              </PrivateRoute>
            }
          />

          {/* ACCOUNT */}
          <Route
            path="/account-settings"
            element={
              <PrivateRoute>
                <AccountSettings />
              </PrivateRoute>
            }
          />

          <Route
            path="/account-profile"
            element={
              <PrivateRoute>
                <AccountProfile />
              </PrivateRoute>
            }
          />

          {/* NOT FOUND */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;